<template>
  <path fill="#26758e" :style="{ fill : $attrs.fgColor }"
        d="m23.27,0h1.45c3.65.12,7.28,1.03,10.51,2.72,4.89,2.51,8.83,6.73,10.95,11.72,1.66,3.88,2.19,8.21,1.57,12.37-.82,5.63-3.86,10.9-8.34,14.53-.01,2.03,0,4.07,0,6.1.02.25-.14.46-.36.57h-.11c-.38-.06-.7-.29-1.03-.46-1.59-.84-3.16-1.69-4.76-2.52-4.92,2.01-10.54,2.3-15.67.89-4.81-1.31-9.16-4.14-12.26-7.96-2.13-2.61-3.68-5.67-4.51-8.91-1.17-4.59-.88-9.53.85-13.95C3.4,10.32,6.91,6.18,11.36,3.5,14.93,1.33,19.08.14,23.27,0Zm3.68,9.73c-2.02.77-3.83,2.13-4.95,3.97-1.18,1.89-1.65,4.18-1.34,6.37.29,2.12,1.32,4.07,1.61,6.19.17,1.21.07,2.47-.41,3.61-.69,1.68-2.09,3.07-3.81,3.74-1.38.56-2.93.6-4.37.26-.56-.13-1.08-.39-1.59-.63-.18-.03-.21.13-.12.24,1.7,2.18,4.09,3.82,6.76,4.66,2.69.85,5.64.89,8.34.09,2.75-.8,5.28-2.42,6.99-4.68,1.33-1.77,1.97-3.99,1.91-6.18-.05-2.67-1.07-5.26-2.62-7.44-1.31-1.88-2.97-3.57-3.83-5.71-.65-1.6-.12-3.53,1.21-4.65.12-.1.27-.19.29-.35-1.37-.11-2.78.03-4.07.51Z"/>
</template>

<script>
export default {
  name: "svgSoroush"
}
</script>

<style scoped>

</style>